import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

const GetTicketBonus = gql`
  query GetTicketBonus($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      id
      job {
        id
      }
      bonus_type
      billing_revenue
      billing_hours
      ticket_number {
        id
        number
      }
      isTrucking: trucking
      district {
        name
      }
      department {
        name
      }
      user_ticket_bonus_forms {
        id
        bonus_percentage
        bonus_rate
        notes
        user_bonus_eligible
        worked_hours {
          to_string
        }
        ticket {
          id
          billing_revenue
          billing_hours
        }
        user {
          id
          fullname
        }
      }
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const [ticket] = querySelector(data, '$.ticket', []);
  const [userTicketBonusForms] = querySelector(data, '$.ticket.user_ticket_bonus_forms', []);

  return {
    ...ownProps,
    data,
    ticket,
    userTicketBonusForms,
  };
};

const queryTicketBonusData = graphql(GetTicketBonus, {
  props: marshallData,
});

export const queryGetTicketBonusGQL = compose(
  queryTicketBonusData,
  queryMetaHandler,
  omitProps(['data']),
);
